/* eslint-disable no-throw-literal */
import {
  GET_STOCK_SHOPMASTER_NOTICE_EXIST
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_STOCK_SHOPMASTER_NOTICE_EXIST] ({dispatch}, params) {
      const res = await dispatch('apiGet', {url: '/asovi/stock_shopmaster_notices/get_stock_shopmaster_notice_exist', data: params})
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/stock-shopmaster-notice.js